export class ListTestResourceSnapshots200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<ListTestResourceSnapshots200ResponseSnapshotsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTestResourceSnapshots200Response.attributeTypeMap;
    }
    constructor() {
    }
}
